<app-chart-wrapper [title]="'Deposit Balance'" [showExpandIcons]="false">
    <app-chart-filter filter [form]="depositBalanceForm" [formControls]="depositBalanceFormControls" (filter)="filterDepositBalance($event)"></app-chart-filter>
    <app-doughnut-chart chart></app-doughnut-chart>
</app-chart-wrapper>